import { format, parseISO } from 'date-fns'
import {formatForTimezone} from '../../modules/utilities/dates.js'
import { displayNumber } from '../../modules/utilities/numbers.js'
import { displayReportResults } from '../../modules/ui.js'

const reportTemplate = document.getElementById('tmpl-report-yardsheets')

export default class MTReportYardsheet extends HTMLElement {
    constructor() {
        super()
        this.attachShadow({ mode: 'open' })
        this.shadowRoot.appendChild(reportTemplate.content.cloneNode(true))

        this.effectiveDateElement = this.shadowRoot.querySelector(
            '.js-effective-date'
        )

        this.errorElement = this.shadowRoot.querySelector('#js-error-container')

        this.printElement = this.shadowRoot.querySelector('#js-print-report')
        this.printElement.addEventListener(
            'click',
            () => {
                this.dispatchEvent(new CustomEvent('printReportEvent'))
            },
            false
        )
    }

    set data(value) {
        const effectiveDate = document.querySelector('#effectiveDate').value

        const ed = parseISO(effectiveDate)
        this._data = value

        this._results = value.reportData

        this._summary = {
            receiveHead: value.receiveHead,
            liveHead: value.liveHead,
            hospitalHead: value.hospitalHead,
            shipHead: value.shipHead,
            deadHead: value.deadHead,
            totalPulls: value.totalPulls,
            cattleCWT: value.cattleCWT,
            inWeight: value.inWeight,
            consumption14: value.consumption14,
            consumptionLTD: value.consumptionLTD,
            averageDailyCost: value.averageDailyCost,
            effectiveDate: new Date(ed),
        }

        if (this._data.hasError) {
            this.displayError()
        } else {
            this.displaySummary()
            displayReportResults(this, '#js-yardsheet-results-container')
        }
    }

    displayError() {
        console.log(this._data.errorMessage)
        this.errorElement.innerText = this._data.errorMessage
    }

    summaryTemplate(props) {
        return `
            <div class="summary-card">
                <dt class="summary-label">
                    Received Head
                </dt>
                <dd class="summary-content summary-received-head">${displayNumber(
                    props.receiveHead,
                    1
                )}</dd>
            </div>
            <div class="summary-card">
                <dt class="summary-label">
                    Live Head
                </dt>
                <dd class="summary-content summary-received-head">${displayNumber(
                    props.liveHead,
                    1
                )}</dd>
            </div>
            <div class="summary-card">
                <dt class="summary-label">
                    Hospital Head
                </dt>
                <dd class="summary-content summary-received-head">${displayNumber(
                    props.hospitalHead,
                    1
                )}</dd>
            </div>
            <div class="summary-card">
                <dt class="summary-label">
                    Shipped Head
                </dt>
                <dd class="summary-content summary-received-head">${displayNumber(
                    props.shipHead,
                    1
                )}</dd>
            </div>
            <div class="summary-card">
                <dt class="summary-label">
                    Dead Head
                </dt>
                <dd class="summary-content summary-received-head">${displayNumber(
                    props.deadHead,
                    1
                )}</dd>
            </div>
            <div class="summary-card">
                <dt class="summary-label">
                    Total Pulls
                </dt>
                <dd class="summary-content summary-received-head">${displayNumber(
                    props.totalPulls,
                    1
                )}</dd>
            </div>
            <div class="summary-card">
                <dt class="summary-label">
                    Delivered Cattle Cost / CWT
                </dt>
                <dd class="summary-content summary-received-head">${displayNumber(
                    props.cattleCWT,
                    2
                )}</dd>
            </div>
            <div class="summary-card">
                <dt class="summary-label">
                    Average in Weight
                </dt>
                <dd class="summary-content summary-received-head">${displayNumber(
                    props.inWeight,
                    0
                )}</dd>
            </div>
            <div class="summary-card">
                <dt class="summary-label">
                    14 Day As Fed Consumption
                </dt>
                <dd class="summary-content summary-received-head">${displayNumber(
                    props.consumption14,
                    1
                )}</dd>
            </div>
            <div class="summary-card">
                <dt class="summary-label">
                    Life-to-Date As Fed Consumption
                </dt>
                <dd class="summary-content summary-received-head">${displayNumber(
                    props.consumptionLTD,
                    1
                )}</dd>
            </div>
            <div class="summary-card">
                <dt class="summary-label">
                    Average Daily Cost
                </dt>
                <dd class="summary-content summary-received-head">${displayNumber(
                    props.averageDailyCost,
                    2
                )}</dd>
            </div>
        `
    }

    displaySummary() {
        this.effectiveDateElement = this.shadowRoot.querySelector(
            '.js-effective-date'
        )
        console.log(this._summary.effectiveDate)
        this.effectiveDateElement.innerText = format(
            this._summary.effectiveDate,
            'MM/dd/yyyy'
        )
        this.summaryListElement = this.shadowRoot.querySelector(
            '#js-summary-list'
        )

        const summary = this.summaryTemplate(this._summary)

        this.summaryListElement.innerHTML = summary
    }

    locationResultsRow(props) {
        const pen = props.PEN !== null ? props.PEN.split(',').join(', ') : ''

        const avgerageInDate =
            props.AVG_IN_DATE !== null
                ? formatForTimezone(props.AVG_IN_DATE, 'MM/dd/yy')
                : ''

        const projectedOutDate =
            props.PROJ_OUT_DATE !== null
                ? formatForTimezone(props.PROJ_OUT_DATE, 'MM/dd/yy')
                : ''

        return `
            <tr class="report-data--row">
                <td class="left lot">
                    ${props.LOT ?? ''}
                </td>
                <td class=" left pen">
                    ${pen}
                </td>
                <td class="right ownership-percentage">
                    ${displayNumber(props.OWNER_PERCENT, 1)}
                </td>
                <td class="left sex">
                    ${props.SEX ?? ''}
                </td>
                <td class="left origin">
                    ${props.ORIGIN ?? ''}
                </td>
                <td class="center average-in-date">
                    ${avgerageInDate}
                </td>
                <td class="right cattle-cwt">
                    ${displayNumber(props.TOTAL_DELIVERED_COST_CWT, 2)}
                </td>
                <td class="right receive">
                    ${displayNumber(props.RECV, 1)}
                </td>
                <td class="right head">
                    ${displayNumber(props.LIVE, 1)}
                </td>
                <td class="right head">
                    ${displayNumber(props.HOSP, 1)}
                </td>
                <td class="right head">
                    ${displayNumber(props.SHIP, 1)}
                </td>
                <td class="right head">
                    ${displayNumber(props.DEAD, 1)}
                </td>
                <td class="right total-pulls">
                    ${displayNumber(props.TOTAL_PULL, 1)}
                </td>
                <td class="right in-weight">
                    ${displayNumber(props.IN_WT, 0)}
                </td>
                <td class="right current-weight">
                    ${displayNumber(props.CURR_WT, 0)}
                </td>
                <td class="right adg">
                    ${displayNumber(props.ADG, 2)}
                </td>
                <td class="right dof">
                    ${displayNumber(props.DOF, 0)}
                </td>
                <td class="right consumption-14">
                    ${displayNumber(props.QTY_14_PER_HEAD, 1)}
                </td>
                <td class="right consumption-ltd">
                    ${displayNumber(props.QTY_LTD_PER_HEAD, 1)}
                </td>
                <td class="right average-daily-cost">
                    ${displayNumber(props.ADC, 2)}
                </td>
                <td class="projected-out-date">
                    ${projectedOutDate}
                </td>
                <td class="right projected-out-weight">
                    ${displayNumber(props.PROJ_OUT_WEIGHT, 0) ?? 0}
                </td>
            </tr>
        `
        //format(props.PROJ_OUT_DATE, 'MM-dd-yy')}
    }

    calculateLocationTotals(a, l) {
        console.log(l.HOME)
        const transferOut = l.TRANSFER_OUT ?? 0
        return {
            receive: a.receive + l.RECV,
            netReceive: a.netReceive + l.RECV - transferOut,
            live: a.live + l.LIVE,
            hospital: a.hospital + l.HOSP,
            shipped: a.shipped + l.SHIP,
            dead: a.dead + l.DEAD,
            pulls: a.pulls + l.TOTAL_PULL,
            home: a.home + l.HOME,
            transfers: a.transfers + transferOut,
            totals: {
                cattleCWT:
                    a.totals.cattleCWT + l.TOTAL_DELIVERED_COST_CWT * l.RECV,
                inWeight: a.totals.inWeight + l.IN_WT * l.RECV,
                currentWeight: a.totals.currentWeight + l.CURR_WT * l.LIVE,
                adg: a.totals.adg + l.ADG * l.RECV,
                dof: a.totals.dof + l.DOF * l.RECV,
                consumption14:
                    a.totals.consumption14 + l.QTY_14_PER_HEAD * l.HOME,
                consumptionLTD:
                    a.totals.consumptionLTD + l.QTY_LTD_PER_HEAD * l.RECV,
                averageDailyCost: a.totals.averageDailyCost + l.ADC * l.RECV,
                projectedOutWeight:
                    a.totals.projectedOutWeight +
                    (l.PROJ_OUT_WEIGHT ?? 0) * l.RECV,
            },
        }
    }

    locationTotalsAccumulator() {
        return {
            receive: 0,
            netReceive: 0,
            home: 0,
            transfers: 0,
            live: 0,
            hospital: 0,
            shipped: 0,
            dead: 0,
            pulls: 0,
            totals: {
                cattleCWT: 0,
                inWeight: 0,
                currentWeight: 0,
                adg: 0,
                dof: 0,
                consumption14: 0,
                consumptionLTD: 0,
                averageDailyCost: 0,
                projectedOutWeight: 0,
            },
        }
    }

    locationNoResultsTemplate(props) {
        return `
            <div class="mt-well mt-template-indent" data-location-id="${props.locationID}">
                <div class="mt-well--content">
                <h3 class="mt-report-title">${props.locationName}</h3>
                    <p>There are no results for ${props.locationName} during this timeframe.</p>
                </div>
            </div>
            `
    }

    locationResultsTemplate(props) {
        const total = props.data.reduce(
            this.calculateLocationTotals,
            this.locationTotalsAccumulator()
        )
        console.info({ total })
        return `
            <div class="mt-well" data-location-id="${props.locationID}" data-collapsible-id="${props.locationID}" data-collapsed="false">
                <div class="mt-well--content">
                    <h3 class="mt-report-title">
						<svg id="collapse-${props.locationID}" data-collapsed="false" class="h-3 w-3 md:h-6 md:w-6" fill="var(--color-action)" viewBox="-150 -350 900 900" height="1.5rem" aria-hidden="true" style="cursor:pointer;">
			            	<path name="expand-icon"
			                  d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm144 276c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92h-92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z" />
			                <path name="collapse-icon"
			                  d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zM124 296c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12H124z" />
			            </svg>
						${props.locationName}
					</h3>
                    <div class="mt-table--container">
                    <table class="js-report--table mt-table">
                <thead class="mt-table--head">
                    <tr>
                        <th scope="col" class="left lot collapsed-hidden">
                            Lot
                        </th>
                        <th scope="col" class="left pen collapsed-hidden">
                            Pen
                        </th>
                        <th scope="col" class="right ownership-percentage collapsed-hidden">
                            <abbr title="Ownership Percentage">Owner%</abbr>
                        </th>
                        <th scope="col" class="left sex collapsed-hidden">
                            Sex
                        </th>
                        <th scope="col" class="left origin collapsed-hidden">
                            Origin
                        </th>
                        <th scope="col" class="center average-in-date collapsed-hidden">
                            <abbr title="Average in Date">Avg In</abbr>
                        </th>
                        <th scope="col" class="right cattle-cwt">
                            <abbr title="Delivered Cattle Cost / CWT">Cattle / CWT</abbr>
                        </th>
                        <th scope="col" class="right receive">
                            Receive
                        </th>
                        <th scope="col" class="right live">
                            Live
                        </th>
                        <th scope="col" class="right hospital">
                            Hosp
                        </th>
                        <th scope="col" class="right ship">
                            Ship
                        </th>
                        <th scope="col" class="right dead">
                            Dead
                        </th>
                        <th scope="col" class="right total-pulls">
                            Total Pulls
                        </th>
                        <th scope="col" class="right average-in-weight">
                            <abbr title="In Weight">In Wt</abbr>
                        </th>                        
                        <th scope="col" class="right current-weight">
                            <abbr title="Current Weight">Curr Wt</abbr>
                        </th>
                        <th scope="col" class="right adg">
                            <abbr title="Average Daily Gain">ADG</abbr>
                        </th>
                        <th scope="col" class="right dof">
                            <abbr title="Days on Feed">DOF</abbr>
                        </th>
                        <th scope="col" class="right consumption-14">
                            <abbr title="14 Day Consumption">14D Cons</abbr>
                        </th>
                        <th scope="col" class="right consumption-ltd">
                            <abbr title="Life-to-Date Consumption">LTD Cons</abbr>
                        </th>
                        <th scope="col" class="right average-daily-cost">
                            <abbr title="Average Daily Cost">Avg Dly Cost</abbr>
                        </th>
                        <th scope="col" class="center projected-out-date collapsed-hidden">
                            <abbr title="Projected Out Date">Proj Out</abbr>
                        </th>
                        <th scope="col" class="right projected-out-weight">
                            <abbr title="Projected Out Weight">Proj Out Wt</abbr>
                        </th>
                    </tr>
                </thead>
                <tbody>
                ${props.data.map(this.locationResultsRow).join('')}
                </tbody>
                <tfoot>                
                    <tr>
                        <th scope="row" class="total" colspan="6">Total</th>
                        <td class="footer-total cattle-cwt">${displayNumber(
                            total.totals.cattleCWT / total.receive,
                            2
                        )}</td>
                        <td class="footer-total receive">${displayNumber(
                            total.netReceive,
                            1
                        )}</td>
                        <td class="footer-total live">${displayNumber(
                            total.live,
                            1
                        )}</td>
                        <td class="footer-total hospital">${displayNumber(
                            total.hospital,
                            1
                        )}</td>
                        <td class="footer-total ship">${displayNumber(
                            total.shipped,
                            1
                        )}</td>
                        <td class="footer-total dead">${displayNumber(
                            total.dead,
                            1
                        )}</td>
                        <td class="footer-total total-pulls">${displayNumber(
                            total.pulls,
                            1
                        )}</td>
                        <td class="footer-total average-in-weight">${displayNumber(
                            total.totals.inWeight / total.receive,
                            0
                        )}</td>
                        <td class="footer-total current-weight">${displayNumber(
                            total.totals.currentWeight / total.live,
                            0
                        )}</td>
                        <td class="footer-total adg">${displayNumber(
                            total.totals.adg / total.receive,
                            2
                        )}</td>
                        <td class="footer-total dof">${displayNumber(
                            total.totals.dof / total.receive,
                            0
                        )}</td>
                        <td class="footer-total cosumption-14">${displayNumber(
                            total.totals.consumption14 / total.home,
                            1
                        )}</td>
                        <td class="footer-total cosumption-ltd">${displayNumber(
                            total.totals.consumptionLTD / total.receive,
                            1
                        )}</td>
                        <td class="footer-total average-daily-cost">${displayNumber(
                            total.totals.averageDailyCost / total.receive,
                            2
                        )}</td>
                        <td>&nbsp;</td>                 
                        <td class="footer-total projected-out-weight">${displayNumber(
                            total.totals.projectedOutWeight / total.receive,
                            0
                        )}</td>
                    </tr>
                </tfoot>
                </table>
                </div>
    </div>
  </div>            
        `
    }

    connectedCallback() {}

    render() {}
}
customElements.define('mt-report-yardsheet', MTReportYardsheet)
